import * as Actions from './type';
import {
  addCustomerVehicleApi,
  getCustomerList,
  getCustomer,
  updateCustomerApi,
  getServiceHistoryApi,
  exportCustomerAPi,
  importCustomerVehicleApi,
  addCustomerApi,
  deleteCustomerApi,
  searchCustomerApi,
} from '../../api/customer/customer-api';
import { Toast } from '../../components/Toast/Toast';

export const addCustomerVehicle = (cusVehData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.ADD_CUSTOMER_VEHICLE_REQUEST,
    });
    const { data } = await addCustomerVehicleApi(cusVehData);
    dispatch({
      type: Actions.ADD_CUSTOMER_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.ADD_CUSTOMER_VEHICLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const addCustomer = (customer) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.ADD_CUSTOMER_REQUEST,
    });
    const { data } = await addCustomerApi(customer);
    dispatch({
      type: Actions.ADD_CUSTOMER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.ADD_CUSTOMER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const clearAddCustomerStates = () => (dispatch) => {
  dispatch({
    type: Actions.CLEAR_ADD_CUSTOMER_STATE,
  });
};

export const clearAddCustomerVehicleStates = () => (dispatch) => {
  dispatch({
    type: Actions.CLEAR_ADD_CUSTOMER_VEHICLE_STATE,
  });
};

export const CustomerList = (query) => async (dispatch) => {
  // query only for sale summary to get all customer with deleted
  try {
    dispatch({
      type: Actions.GET_CUSTOMER_LISTING_REQUEST,
    });
    const { data } = await getCustomerList(query);
    dispatch({
      type: Actions.GET_CUSTOMER_LISTING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_CUSTOMER_LISTING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteCustomer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.DELETE_CUSTOMER_REQUEST,
    });
    const { data } = await deleteCustomerApi(id);
    dispatch({
      type: Actions.DELETE_CUSTOMER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.DELETE_CUSTOMER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getSingleCustomer = (customerId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_CUSTOMER_REQUEST,
    });
    const { data } = await getCustomer(customerId);
    dispatch({
      type: Actions.GET_CUSTOMER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_CUSTOMER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateCustomer = (customerData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_CUSTOMER_REQUEST,
    });
    const { data } = await updateCustomerApi(customerData);
    dispatch({
      type: Actions.UPDATE_CUSTOMER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_CUSTOMER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getServiceHistory = (dt) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_SERVICE_HISTORY_REQUEST,
    });
    const { data } = await getServiceHistoryApi(dt);
    dispatch({
      type: Actions.GET_SERVICE_HISTORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_SERVICE_HISTORY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const exportCustomer = (query) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.EXPORT_CUSTOMER_REQUEST,
    });
    const { data } = await exportCustomerAPi(query);
    dispatch({
      type: Actions.EXPORT_CUSTOMER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.EXPORT_CUSTOMER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const importCustomerVehicle =
  (file, handleUploadProgress) => async (dispatch) => {
    const formData = new FormData();
    formData.append('file', file?.[0]);

    try {
      dispatch({
        type: Actions.IMPORT_CUSTOMER_VEHICLE_REQUEST,
      });
      const { data } = await importCustomerVehicleApi(
        formData,
        handleUploadProgress,
      );
      dispatch({
        type: Actions.IMPORT_CUSTOMER_VEHICLE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: Actions.IMPORT_CUSTOMER_VEHICLE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const searchCustomer = (_data) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEARCH_CUSTOMER_REQUEST,
    });
    const { data } = await searchCustomerApi(_data);
    dispatch({
      type: Actions.SEARCH_CUSTOMER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    Toast('error', message);

    dispatch({
      type: Actions.SEARCH_CUSTOMER_FAIL,
      payload: message,
    });
  }
};
